import ctaImg from '../../images/preview/footer.jpg'

const FooterSection = (props) => {

    return (
         <div>
            <footer className="preview-site-footer" style={{ backgroundImage: `url(${ctaImg})` }}>
                <div className="preview-upper-footer">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="preview-footer-text">
                                    <span className="poort-text poort-in-right">Everything your Want for Your Wedding</span>
                                    <h2 className="poort-text poort-in-right">Let’s Celebrate Love With Bohu</h2>
                                    <a className="theme-btn wow fadeInUp" data-wow-duration="1800ms" target='_blank' rel="noreferrer"
                                        href="https://1.envato.market/vPL4xO">Purchase Now </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="pthumb"><div className="thumb-inner"><h2>6 <small>+</small> <span>Home</span></h2></div></div>
            <div className="pthumb2"><div className="thumb-inner"><h2>30 <small>+</small> <span>Pages</span></h2></div></div>
         </div>
    );
}

export default FooterSection;